import { createSlice } from "@reduxjs/toolkit";
import { tokenManager } from "../../../Api/tokenManager";
import { sendOtp, resendOtp, verifyOtp, completeProfile } from "../Thunk/authThunk";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    otpLoading: false,
    otpSuccess: null,
    otpError: null,

    verifyLoading: false,
    verifySuccess: null,

    profileLoading: false,
    profileSuccess: null,
    profileError: null,

    token: localStorage.getItem("token") || null,
  },

  reducers: {
    logout: (state) => {
      state.token = null;
      tokenManager.clearRole("patient");
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
    },
    clearAuthError: (state) => {
      state.otpError = null;
      state.profileError = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(sendOtp.pending, (state) => {
        state.otpLoading = true;
        state.otpError = null;
      })
      .addCase(sendOtp.fulfilled, (state, action) => {
        state.otpLoading = false;
        state.otpSuccess = action.payload;
      })
      .addCase(sendOtp.rejected, (state, action) => {
        state.otpLoading = false;
        state.otpError = action.payload;
      })

      .addCase(resendOtp.pending, (state) => {
        state.otpLoading = true;
        state.otpError = null;
      })
      .addCase(resendOtp.fulfilled, (state, action) => {
        state.otpLoading = false;
        state.otpSuccess = action.payload;
      })
      .addCase(resendOtp.rejected, (state, action) => {
        state.otpLoading = false;
        state.otpError = action.payload;
      })

      .addCase(verifyOtp.pending, (state) => {
        state.verifyLoading = true;
        state.otpError = null;
      })
      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.verifyLoading = false;
        state.verifySuccess = action.payload;

        const accessToken =
          action.payload?.accessToken ||
          action.payload?.token ||
          action.payload?.data?.accessToken ||
          action.payload?.data?.token ||
          null;

        const refreshToken =
          action.payload?.refreshToken ||
          action.payload?.data?.refreshToken ||
          null;

        if (accessToken) localStorage.setItem("token", accessToken);
        if (refreshToken) localStorage.setItem("refreshToken", refreshToken);

        state.token = accessToken || null;
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.verifyLoading = false;
        state.otpError = action.payload;
      })

      .addCase(completeProfile.pending, (state) => {
        state.profileLoading = true;
        state.profileError = null;
        state.profileSuccess = null;
      })
      .addCase(completeProfile.fulfilled, (state, action) => {
        state.profileLoading = false;
        state.profileSuccess = action.payload;
      })
      .addCase(completeProfile.rejected, (state, action) => {
        state.profileLoading = false;
        state.profileError = action.payload;
      });
  },
});

export const { logout, clearAuthError } = authSlice.actions;
export default authSlice.reducer;
